import { useMatomo } from '@datapunt/matomo-tracker-react';
import React, { useEffect } from 'react';

import Header from '@components/common/Header/Header';
import Select from '@components/uikit/Select/Select';

import { getAIUrgenciesList } from '@helpers/getAIUrgenciesList';

import useTranslation from '@hooks/useTranslation';

import { useAssetHealthOverviewQuery } from '@pages/ExecutiveSummary/services/useAssetHealthOverviewQuery';
import {
  selectAssetHealthUrgency,
  useAssetHealthOverviewStoreActions,
} from '@pages/ExecutiveSummary/store/useAssetHealthOverviewFilterStorePersist';

import { selectAppLocationSelectValue } from '@store/useAppStore';

import AssetHealthOpenAi from './components/AssetHealthOpenAi/AssetHealthOpenAi';
import CauseCategoryTable from './components/CauseCategoryTable/CauseCategoryTable';
import EquipmentTable from './components/EquipmentTable/EquipmentTable';
import style from './style.module.scss';

const AssetHealthDetails = () => {
  const { t } = useTranslation();
  const { trackPageView } = useMatomo();
  const urgenciesList = getAIUrgenciesList(t);
  const urgency = selectAssetHealthUrgency();

  const locationSelectValue = selectAppLocationSelectValue();
  const { setAssetHealthUrgency } = useAssetHealthOverviewStoreActions();

  const { data, isPlaceholderData } = useAssetHealthOverviewQuery({
    locationIds:
      locationSelectValue.level_name === 'allFacilities' ? undefined : locationSelectValue?.filterIds,
    urgency: urgency.value === 'all' ? undefined : urgency.value,
  });

  useEffect(() => {
    trackPageView({});
  }, []);

  return (
    <>
      <Header title={t('Asset Health Details')} showLogo showFacilitySelect isSecondaryPage />
      <div className={style.assetHealthDetails}>
        <div className={style.assetHealthDetailsInfoBlock}>
          <div className={style.assetHealthDetailsFilters}>
            <Select
              value={urgency.value === 'all' ? urgenciesList[0] : urgency}
              onChange={setAssetHealthUrgency}
              options={urgenciesList}
              label={t('Urgency')}
              className={style.urgencyFilter}
              itemKeys={{ valueFieldKey: 'value', labelFieldKey: 'label' }}
              type="woHelperText"
            />
          </div>
          <AssetHealthOpenAi
            title={t('Active Action Items by Sensor')}
            isLoading={isPlaceholderData}
            criticalAiCount={data?.sensors.critical_regular_ais_count}
            highAiCount={data?.sensors.high_regular_ais_count}
            standardAiCount={data?.sensors.standard_regular_ais_count}
          />
          <AssetHealthOpenAi
            title={t('Active Action Items by Asset')}
            isLoading={isPlaceholderData}
            criticalAiCount={data?.equipment.critical_regular_ais_count}
            highAiCount={data?.equipment.high_regular_ais_count}
            standardAiCount={data?.equipment.standard_regular_ais_count}
          />
        </div>
        <div className={style.tableWrapper}>
          <div className={style.leftBlock}>
            <EquipmentTable />
          </div>
          <div className={style.rightBlock}>
            <CauseCategoryTable />
          </div>
        </div>
      </div>
    </>
  );
};

export default AssetHealthDetails;
